var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-frequency-tag xs-f-xxsmall max-at-tweak"},[_vm._t("default"),_c('span',{staticClass:"upper inline-block"},[_vm._v("Delivered every "+_vm._s(_vm.frequency)+" weeks")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }